<template>
  <v-row no-gutters>
    <v-col cols="6" class="_pr-">
      <ColorPickerV2 title="Cor do ingresso" :colorSelected="selectedSection" type="item-background-color" /> 
    </v-col>
    <v-col cols="6" class="_pl-">
      <Select 
      label="Máximo de colunas"
      v-model="selectedSection['max-columns']" 
      :items="columnsOptions" 
      :showBorder="true"
      /> 
    </v-col>
  </v-row>
</template>

<script>
import ColorPickerV2 from '../../../../_v2/ui/ColorPickerV2.vue'
import Select from '../../../../_v2/ui/Select.vue'

export default {
  name: 'Layout2',
  components: {ColorPickerV2, Select},
  props: {
    selectedSection: {type: Object, required: true}
  },

  data: () => ({
    columnsOptions: [2, 3, 4]    
  })    
}
</script>